
import React from 'react'
import {connect} from "react-redux";
import {servidor, servicioRestfulCompleto, servicioRestfulMinimo} from "../Configuracion";
import {
    CELLTIPO_CADENA, CELLTIPO_COLOR,
    CELLTIPO_ENTERO,
    CELLTIPO_FOREIGN, CELLTIPO_ICONOACCION, COLUMNVISIBLE_SIEMPRE,
} from "../../framework2/ej2/UI/TiposCeldas";
import "../resources/css/encabezado.css";
import "../resources/css/selectorperiodo.css";
import FormularioBotonera, {
    BOTONERA_ACCION_EXCEL, BOTONERA_ACCION_NUEVO, BOTONERA_ACCION_REFRESCAR,
    BOTONERA_REFRESCAR
} from "../../framework2/ej2/UI/FormularioBotonera";
import ClienteRestful from "../../framework2/ej2/network/ClienteRestful";
import {Icon, Intent, Spinner} from "@blueprintjs/core";
import GridRDG from "../../framework2/adazzle/GridRDG";
import Titulo from "../../framework2/ej2/UI/Titulo";
import Paciente from "./Paciente";
import {
    COMPONENTE_TIPO_BOOL, COMPONENTE_TIPO_CODIGOID, COMPONENTE_TIPO_IDFISCAL,
    COMPONENTE_TIPO_DATE, COMPONENTE_TIPO_FECHA,
    COMPONENTE_TIPO_FOREIGN,
    COMPONENTE_TIPO_INPUT,
    COMPONENTE_TIPO_MEMO,
    COMPONENTE_TIPO_SELECT, getValorCampo,
    loadDato,
    loadDatos,
    loadDatosServicio, onKeyDown,
    renderFormulario,
    renderGrid,
    showComponente, showInputBusqueda,
    showSelectBusqueda, COMPONENTE_TIPO_POBLACION, postServicioBloqueante
} from "../utils/FormularioUtils";
import Pago from "./Pago";
import PropTypes from "prop-types";
import {loadServicioEntidad} from "../../framework2/ej2/utils/EntidadJPAUtils";
import SelectorPeriodo from "../../framework2/ej2/UI/SelectorPeriodo";
import {getDispositivo} from "../utils/WindowUtils";
import AvisoModalServicio from "../../framework2/ej2/UI/AvisoModalServicio";

class Pacientes extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showGrid: true,
            cargandoDatos: false,
            elementoSeleccionado: null,
            datos: [],
            elementoShow: false,
            marcaTiempo: new Date(),

            filtroNombre: null,
            filtroCodigoid: null,
            filtroDoctorCodigo: 0,
            filtroClinicaCodigo: null,
            filtroDNI: null,
            filtroTelefonos: null,
            filtroContacto: null,
            filtroDireccion: null,
            filtroPoblacion: null,
        }

        this.columnas= [
            {campo:"codigoid", titulo: "Código", tipo: CELLTIPO_CADENA, ancho:70},
            //{campo:"numero_historial", titulo: "Num. Historial", tipo: CELLTIPO_CADENA, ancho:100},
            {campo:"nombre", titulo: "Nombre", tipo: CELLTIPO_CADENA, ancho:300, },
            {campo:"dni", titulo: "DNI", tipo: CELLTIPO_CADENA, ancho:100, },
            //{campo:"direccion", titulo: "Direccion", tipo: CELLTIPO_CADENA, ancho:200,},
            //{campo:"población", titulo: "Población", tipo: CELLTIPO_CADENA, ancho:70},
            {campo:"telefonos", titulo: "Teléfonos", tipo: CELLTIPO_CADENA, ancho:120},
            {campo:"contacto", titulo: "Contacto", tipo: CELLTIPO_CADENA, ancho:120, },
            {campo:"email", titulo: "email", tipo: CELLTIPO_CADENA, ancho:180},
            {campo:"doctorCodigo.nombre", titulo: "Doctor", tipo: CELLTIPO_CADENA, ancho:200,},
            //{campo:"clinicaCodigo.nombre", titulo: "Clínica", tipo: CELLTIPO_CADENA, ancho:100,},
        ];
        //Si no hay llamador de selección inseramos en la primera posición la columna M
        if (!props.llamador){
            this.columnas.unshift(
                {campo: "M", titulo: "M", tipo: CELLTIPO_ICONOACCION,  ancho: 40,  visibilidad: COLUMNVISIBLE_SIEMPRE,
                    icon: "edit",
                    onAccion: (elemento) => {
                    console.log(elemento);
                    this.setState({elementoSeleccionado: elemento, showGrid: false })
                    }
                }
            );
        }

        this.elementoConfig= {
            className: "Paciente",
            secciones: [
                {
                    titulo: "Datos Administrativos",
                    campos: [
                        {campo: "codigoid", titulo: "Número", tipo: COMPONENTE_TIPO_CODIGOID, cols: 1, obligatorio: true,},
                        {campo: "nombre", titulo: "Nombre", tipo: COMPONENTE_TIPO_INPUT, cols: 3},
                        //{campo: "fechanacimiento", titulo: "Fecha nacimiento", tipo: COMPONENTE_TIPO_DATE, cols: 2},
                        {campo: "fechanacimiento", titulo: "Fecha nacimiento", tipo: COMPONENTE_TIPO_FECHA, cols: 2},
                        {campo: "dni", titulo: "D.N.I.", tipo: COMPONENTE_TIPO_IDFISCAL, cols: 2, maxTamagno:10, obligatorio: true},
                        {campo: "direccion", titulo: "Dirección", tipo: COMPONENTE_TIPO_INPUT, cols: 4, obligatorio: true},
                        //{campo: "poblacion", titulo: "Población", tipo: COMPONENTE_TIPO_POBLACION, cols: 2, obligatorio: true},
                        {campo: "poblacion", titulo: "Población", tipo: COMPONENTE_TIPO_INPUT, cols: 2, obligatorio: true},
                        {campo: "cp", titulo: "CP", tipo: COMPONENTE_TIPO_INPUT, cols: 1, obligatorio: true},
                        {campo: "telefonos", titulo: "Teléfonos", tipo: COMPONENTE_TIPO_INPUT, cols: 4, obligatorio: true},
                        {campo: "email", titulo: "Email", tipo: COMPONENTE_TIPO_INPUT, cols: 4, nomayus: true},
                        {campo: "otros", titulo: "Otros", tipo: COMPONENTE_TIPO_INPUT, cols: 4},
                        {campo: "contacto", titulo: "Contacto", tipo: COMPONENTE_TIPO_INPUT, cols: 4},
                    ]
                },
                {
                    titulo: "Datos Clínica",
                    campos: [
                        {campo: "clinicaCodigo", titulo: "Clínica", tipo: COMPONENTE_TIPO_FOREIGN, valores: props.datosmaestros.clinicas, cols: 2, obligatorio: true},
                        {campo: "doctorCodigo", titulo: "Doctor", tipo: COMPONENTE_TIPO_FOREIGN, valores: props.datosmaestros.doctores, cols: 2, obligatorio: true},
                    ]
                },
                {
                    titulo: "Historia Médica",
                    campos: [
                        {campo: "hisDigestivo", titulo: "Digestivo", tipo: COMPONENTE_TIPO_MEMO, cols: 2},
                        {campo: "hisRenales", titulo: "Renaleas", tipo: COMPONENTE_TIPO_MEMO, cols: 2},
                        {campo: "hisDermatológicos", titulo: "Dermatológicos", tipo: COMPONENTE_TIPO_MEMO, cols: 2},
                        {campo: "hisCardiovasculares", titulo: "Cardiovasculares", tipo: COMPONENTE_TIPO_MEMO, cols: 2},
                        {campo: "hisHematológicos", titulo: "Hematológicos", tipo: COMPONENTE_TIPO_MEMO, cols: 2},
                        {campo: "hisCefaleas", titulo: "Cefaleas", tipo: COMPONENTE_TIPO_MEMO, cols: 2},
                        {campo: "hisMetabolicos", titulo: "Metabólicos (Diabetes)", tipo: COMPONENTE_TIPO_MEMO, cols: 2},
                        {campo: "hisAlergias", titulo: "Alergias", tipo: COMPONENTE_TIPO_MEMO, cols: 4},
                        {campo: "hisAntecedentesFamiliares", titulo: "Antecedentes familiares", tipo: COMPONENTE_TIPO_MEMO, cols: 4, rows:4},
                        //{campo: "hisUltimarevisiondental", titulo: "Última revisión dental", tipo: COMPONENTE_TIPO_INPUT, cols: 4},
                        {campo: "hisMedicacionactual", titulo: "Medicación actual", tipo: COMPONENTE_TIPO_MEMO, cols: 4, rows:4},
                        {campo: "hisOtros", titulo: "Otros", tipo: COMPONENTE_TIPO_MEMO, cols: 4, rows:4, },
                        {campo: "observaciones", titulo: "Observaciones", tipo: COMPONENTE_TIPO_MEMO, cols: 4, rows: 4},
                        {campo: "alertas", titulo: "Alertas", tipo: COMPONENTE_TIPO_MEMO, cols: 4},
                    ]
                },
            ]
        };

        this.inputCodigoIdRef = React.createRef();
    }

    componentDidMount() {
        const{pacienteCodigo} = this.props;
        console.log("PACIENTE - ComponentDidMount");
        console.log("PROPS: ", this.props);
        console.log("pacienteCodigo: ", pacienteCodigo);
        console.log("this.props.datosMaestros: ", this.props.datosMaestros);

        if (pacienteCodigo){
            loadDato(this, "Paciente", pacienteCodigo, ()=> {this.setState({showGrid: false})} );
        }
        //else
        //    this.loadDatos();

        if (this.inputCodigoIdRef.current) {
            this.inputCodigoIdRef.current.focus();
        }
    }


    loadDatos= () =>{
        const {filtroNombre, filtroCodigoid, filtroDoctorCodigo, filtroDNI, filtroContacto, filtroTelefonos, filtroPoblacion, filtroDireccion, filtroClinicaCodigo } = this.state;
        const {estado, paciente} = this.props;

        let parametros= {
            clinicaCodigo: estado.clinica.codigo,
            doctorCodigo: filtroDoctorCodigo ? filtroDoctorCodigo : 0,
            nombre: filtroNombre ? filtroNombre : "",
            codigoid: filtroCodigoid ? filtroCodigoid : "",
            dni: filtroDNI ? filtroDNI : "",
            contacto: filtroContacto ? filtroContacto : "",
            telefonos: filtroTelefonos ? filtroTelefonos : "",
            poblacion: filtroPoblacion ? filtroPoblacion : "",
            direccion: filtroDireccion ? filtroDireccion : "",
        }
        console.log ("PAcientes - LoadDAtos");
        console.log("Parametros: ", parametros);
        loadDatosServicio(this, "Paciente", "getLista", parametros);
    }

    //------------------------------------------------------------------------------------------------------------------
    // ACCIONES
    //------------------------------------------------------------------------------------------------------------------

    onAccion= (accion, elemento) => {
        switch (accion){
            case BOTONERA_ACCION_NUEVO:
                this.nuevoElemento();
                break;

            case BOTONERA_ACCION_REFRESCAR:
                //loadDatos(this, "Paciente");
                this.loadDatos();
                break;
        }
    }

    nuevoElemento= () => {
        const{estado} = this.props;
        console.log("Nuevo Elemento");
        let elemento= {
            clinicaCodigo: estado.clinica,
            doctorCodigo: {codigo: 9999, nombre:"NO DEFINIDO"}
        } ;
        this.setState({elementoSeleccionado: elemento, showGrid: false});
    }

    /*
    getSiguienteCodigoId= () => {
        loadServicioEntidad("Paciente", "getSiguienteCodigoId", {}, ((response) => {
            console.log(response);
            })
        );
    }
    */


    /* ----------------- ELIMINAR  ------------ */

    comprobarElementoEliminar= async () => {
        const {elementoSeleccionado } = this.state;
        //Comprobamos que no tenga inversiones:
        let parametros= {pacienteCodigo: elementoSeleccionado.codigo};

        let datosDependientes= await postServicioBloqueante("Paciente", "getDependencias", parametros);
        console.log("datosDependientes: ", datosDependientes);
        /*
        if (proyectos.length > 0) {
            let mensaje = "El cliente que desea eliminar posee uno o más proyectos asociados. ";
            AvisoModalServicio.showAviso(mensaje);
            return false;
        }
        */
        return true;
    }

    eliminar= () => {
        const {elementoSeleccionado } = this.state;
        const {auth} = this.props;
        let url = servidor + servicioRestfulCompleto + "Paciente" + "/" + elementoSeleccionado.codigo + "/" + "0" + "/" + auth.usuario.codigo;
        const clienteRestful = new ClienteRestful().setUrl(url);
        clienteRestful.doDelete(response => {
            if (clienteRestful.exito && response) {
                let resultado= response;
                if (Boolean(resultado.exito)) {
                    this.loadDatos();
                }
                else{
                    alert(resultado.mensaje);
                }
            }
            else {
                alert("La eliminación no ha podido ser realizada. ");
            }
        });
    }

    onFormularioAceptado= () => {
        const {pacienteCodigo, onAceptarPaciente} = this.props;
        if (!onAceptarPaciente)
            this.setState({showGrid: true}, this.loadDatos);
        else
            onAceptarPaciente();
    }
    onFormularioCancelado= () => {
        const {pacienteCodigo, onAceptarPaciente} = this.props;
        if (!onAceptarPaciente)
            this.setState({showGrid: true});
        else
            onAceptarPaciente();
    }


    /* ----------------- ELIMINAR  ------------ */

    comprobarElementoEliminar= async () => {
        const {elementoSeleccionado } = this.state;
        //Comprobamos que no tenga inversiones:
        let parametros= { codigo: elementoSeleccionado.codigo};
        let dependencias= await postServicioBloqueante("Paciente", "getDependencias", parametros);
        console.log("Dependencias: ", dependencias);
        if (dependencias.numPagos > 0) {
            let mensaje = "El paciente que desea eliminar posee pagos asociados. ";
            AvisoModalServicio.showAviso(mensaje);
            return false;
        }

        if (dependencias.numTratamientos > 0) {
            let mensaje = "El paciente que desea eliminar posee tratamientos asociados. ";
            AvisoModalServicio.showAviso(mensaje);
            return false;
        }

        if (dependencias.numCitas > 0) {
            let mensaje = "El paciente que desea eliminar posee citas asociadas. ";
            AvisoModalServicio.showAviso(mensaje);
            return false;
        }
        return true;
    }
    eliminarElemento= () => {
        const {elementoSeleccionado } = this.state;
        const {auth} = this.props;
        let url= servidor + servicioRestfulMinimo + "Paciente/" + elementoSeleccionado.codigo + "/0/"+ auth.usuarioCodigo;
        const clienteRestful = new ClienteRestful().setUrl(url);
        clienteRestful.doDelete( response => {
            this.loadDatos();
        });
    }

    renderBusquedaPC= () => {
        const {filtroNombre, filtroCodigoid, filtroDoctorCodigo, filtroClinicaCodigo, filtroDNI, filtroContacto, filtroTelefonos,
            filtroDireccion, filtroPoblacion} = this.state;
        const {datosmaestros} = this.props;
        return (
            <div class="fr_contenedor_buscador" >
                {showInputBusqueda("codigoid", "Código", filtroCodigoid,
                    (codigoid) => this.setState({filtroCodigoid: codigoid}),
                                this.loadDatos, this.inputCodigoIdRef) }

                {showInputBusqueda("nombre", "Nombre", filtroNombre,
                    (nombre) => this.setState({filtroNombre: nombre.toUpperCase()}),
                               this.loadDatos) }
                {showInputBusqueda("DNI", "DNI", filtroDNI,
                    (dni) => this.setState({filtroDNI: dni.toUpperCase()}),
                                this.loadDatos) }
                {showInputBusqueda("telefonos", "Teléfonos", filtroTelefonos,
                    (telefonos) => this.setState({filtroTelefonos: telefonos}),
                              this.loadDatos) }
                {showInputBusqueda("contacto", "Contacto", filtroContacto,
                    (contacto) => this.setState({filtroContacto: contacto.toUpperCase()}),
                              this.loadDatos) }
                {showInputBusqueda("direccion", "Dirección", filtroDireccion,
                    (direccion) => this.setState({filtroDireccion: direccion.toUpperCase()}),
                               this.loadDatos ) }
                {showInputBusqueda("poblacion", "Poblacion", filtroPoblacion,
                    (poblacion) => this.setState({filtroPoblacion: poblacion.toUpperCase()}),
                              this.loadDatos) }
                {showSelectBusqueda("sDoctores",  "Doctor", filtroDoctorCodigo, datosmaestros.doctores,
                    (doctorCodigo) => this.setState({filtroDoctorCodigo: Number(doctorCodigo)})   ) }

                <button className="fr_boton refrescar"onClick={this.loadDatos}><Icon icon="refresh" style={{marginRight: 6}}/>Refrescar</button>
            </div>
        );
    }

    renderBusquedaTablet= () => {
        const {filtroNombre, filtroCodigoid, filtroDoctorCodigo, filtroClinicaCodigo, filtroDNI, filtroContacto, filtroTelefonos,
            filtroDireccion, filtroPoblacion} = this.state;
        const {datosmaestros} = this.props;
        return (
            <div class="fr_contenedor_buscador" >
                {showInputBusqueda("codigoid", "Código", filtroCodigoid,
                    (codigoid) => this.setState({filtroCodigoid: codigoid}),
                    this.loadDatos, this.inputCodigoIdRef) }
                {showInputBusqueda("nombre", "Nombre", filtroNombre,
                    (nombre) => this.setState({filtroNombre: nombre.toUpperCase()}),
                    this.loadDatos) }
                {showSelectBusqueda("sDoctores",  "Doctor", filtroDoctorCodigo, datosmaestros.doctores,
                    (doctorCodigo) => this.setState({filtroDoctorCodigo: Number(doctorCodigo)})   ) }
                <button className="fr_boton refrescar"onClick={this.loadDatos}>Refrescar</button>
            </div>
        );
    }

    gridOnDobleClick= (info) => {
        console.log("info: ", info);

        /*
        switch (info.columnKey){
            case "E":
                if (info.objeto.inversion_pagadocalculado < 2) {
                    if (info.objeto.cliente_email == null || info.objeto.cliente_email == "" || info.objeto.cliente_email == "-")
                        AvisoModalServicio.showAviso("El cliente no tiene email asignado");
                    else
                        this.conmutarLiquidacion(info.objeto);
                }
                break;
          */
    }
    render() {
        const {showGrid, datos} = this.state;
        const {onElementoSeleccionado} = this.props;

        let dispositivo= getDispositivo();
        //console.log("this.dispositivo: ", dispositivo);

        let propiedades= {
            onElementoSeleccionado: (elementoSeleccionado) => {
                //console.log("PACIENTES - Propiedades - onElementoSeleccionado");
                //console.log("elementoSeleccionado: ", elementoSeleccionado);
                //console.log("onElementoSeleccionado: ", onElementoSeleccionado);
                //console.log("llamador: ", llamador);
                onElementoSeleccionado && onElementoSeleccionado(elementoSeleccionado);
            }
        }



        return (
            <div style={{margin: 8, padding: 4}}>
                <Titulo titulo="Gestión de Pacientes" soloTitulo={true} />
                {Boolean(showGrid) &&
                    <>
                        { dispositivo == 'desktop' && this.renderBusquedaPC()}
                        { dispositivo == 'tablet' && this.renderBusquedaTablet()}
                        {renderGrid(this, "Pacientes", datos, this.onAccion, propiedades)}
                    </>
                }
                {!Boolean(showGrid) && renderFormulario(this, <Paciente/>)}
            </div>
        )
    }

}

Pacientes.propTypes = {
    pacienteCodigo: PropTypes.number,
    onAceptarPaciente: PropTypes.func,
    onElementoSeleccionado: PropTypes.func,
    llamador: PropTypes.string,
}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
        datosmaestros: state.datosmaestros,
        estado: state.estado,
    }
}
export default connect(mapStateToProps)(Pacientes);



